import { SERVICE_DEBUG } from '../ServiceBooking';

export const debug = (...args) => {
    if (SERVICE_DEBUG) {
        // eslint-disable-next-line no-console
        console.warn(...args);
    }
};

export const debugLog = (name, ...values) => {
    debug(name, ...values);
};
